import { render } from "./profile.view.vue?vue&type=template&id=677f3232&scoped=true&ts=true"
import script from "./profile.view.vue?vue&type=script&lang=ts"
export * from "./profile.view.vue?vue&type=script&lang=ts"

import "./profile.view.vue?vue&type=style&index=0&id=677f3232&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677f3232"]])

export default __exports__